import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface FieldProps {
  id: string;
  label?: string;
  hint?: string;
  error?: string | undefined;
  required?: boolean;
  className?: string;
  children: ReactNode;
}

/** Zajednički okvir za sva polja: labela, opis, greška — uvijek povezani preko id-a. */
export function Field({ id, label, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cx('flex flex-col gap-1.5', className)}>
      {label && (
        <label htmlFor={id} className="text-[13px] text-ink-muted">
          {label}
          {/* Zvjezdica je vizualna oznaka; čitač zaslona dobiva `required` na samom polju. */}
          {required && (
            <span aria-hidden="true" className="text-accent-dark">
              {' '}*
            </span>
          )}
        </label>
      )}
      {children}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-[12px] text-danger">
          {error}
        </p>
      ) : (
        hint && (
          <p id={`${id}-hint`} className="text-[12px] text-ink-muted">
            {hint}
          </p>
        )
      )}
    </div>
  );
}

export const controlClass =
  'w-full rounded-md border bg-surface px-4 py-3 font-body text-[15px] text-ink ' +
  'placeholder:text-ink-muted transition-colors duration-200 ' +
  'disabled:opacity-40 disabled:pointer-events-none';

export function borderClass(invalid?: boolean): string {
  // `border-line` daje 1,28:1 — polje se nije vidjelo dok se ne klikne u njega.
  return invalid ? 'border-danger' : 'border-line-control focus:border-accent';
}
